import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@components/header/header.component';
import { loading$ } from '@interceptors/loading.interceptor';
import { SecurityContextService } from '@services/security_context.service';
import { SidebarComponent } from '@components/sidebar/sidebar.component';
import { tap } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, SidebarComponent, HeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.less',
})
export class AppComponent {
  private _securityContextService = inject(SecurityContextService);

  get isLoggedIn(): boolean {
    return this._securityContextService.isLoggedIn();
  }

  loading$: any;

  // Constants
  isKeyboardDisabled = false;

  // Lifecycle Hooks
  ngOnInit(): void {
    this.loading$ = loading$.pipe(
      tap((isLoading: boolean) => (this.isKeyboardDisabled = isLoading)),
    );
  }

  @HostListener('window:keydown', ['$event'])
  @HostListener('window:keypress', ['$event'])
  @HostListener('window:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.isKeyboardDisabled) event.preventDefault();
  }
}
